// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"f4354a2e","container":"ec827f61","icon":"f3c00a82","iconInput":"cb1ed90d","input":"c8f2ed1b"};